import { render } from "./commentView.vue?vue&type=template&id=7d0dc313&scoped=true"
import script from "./commentView.vue?vue&type=script&lang=js"
export * from "./commentView.vue?vue&type=script&lang=js"

import "./commentView.vue?vue&type=style&index=0&id=7d0dc313&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0dc313"]])

export default __exports__